import styled from 'styled-components';
import { Link } from 'gatsby';

const styles = {
  primary: `
    color: #fff!important;
    border: solid 2px var(--primary-600);
    background: var(--primary-600);
    border-radius: 6px;
    display: inline-block;
    font-size: 1em;
    font-weight: 600;
    padding: 14px 22px;
    transition: box-shadow 0.2s, transform .2s, background 0.2s ease-in-out, border-color 0.2s ease-in-out;
    text-align: center;
    text-decoration: none !important;
    margin-left: 0;
    width: auto;
    white-space: nowrap;

    &:hover {
      background: var(--primary-800);
      border-color: var(--primary-800);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
      color: #fff!important;
      cursor: pointer;
      text-decoration: none;
      // transform: translateY(-1px);
    }

    &:active {
      background: var(--primary-600);
      border-color: var(--primary-600);
    }`,

  secondary: `
    color: var(--primary-400) !important;
    border: solid 2px var(--primary-400);
    background: transparent;
    border-radius: 6px;
    display: inline-block;
    font-size: 1em;
    font-weight: 600;
    text-decoration: none !important;
    padding: 14px 22px;
    transition: box-shadow 0.2s, background 0.1s ease-in-out, border-color 0.1s ease-in-out;
    text-align: center;
    margin-left: 0;
    width: auto;
    white-space: nowrap;

    &:hover {
      background: var(--nude-500);
      border-color: var(--nude-500);
      color: #fff !important;
      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
      cursor: pointer;
      text-decoration: none;
    }
  `,

  light: `  
    color: var(--nude-300);
    border: solid 2px var(--nude-300);
    background: transparent;
    border-radius: 6px;
    box-shadow: none;
    display: inline-block;
    font-size: 1em;
    font-weight: 600;
    text-decoration: none !important;
    padding: 14px 22px;
    transition: box-shadow 0.2s, background 0.1s ease-in-out, border-color 0.1s ease-in-out;
    text-align: center;
    margin-left: 0;
    width: auto;
    white-space: nowrap;

    &:hover {
      background: var(--app-cta-btn);
      border-color: var(--app-cta-btn);
      color: #000;
      cursor: pointer;
      text-decoration: none;
    }`,

  default: `
    color: var(--primary-600) !important;
    border: solid 2px var(--primary-600);
    background: transparent;
    border-radius: 6px;
    display: inline-block;
    font-size: 1em;
    font-weight: 600;
    text-decoration: none !important;
    padding: 14px 22px;
    transition: box-shadow 0.2s, background 0.1s ease-in-out, border-color 0.1s ease-in-out;
    text-align: center;
    margin-left: 0;
    width: auto;
    white-space: nowrap;

    &:hover {
      background: var(--primary-600);
      border-color: var(--primary-600);
      color: #fff !important;
      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
      cursor: pointer;
      text-decoration: none;
    }
  `,

  dark: `
    background: transparent;
    border-radius: 6px;
    border: solid 2px #444;
    color: #444 !important;
    display: inline-block;
    font-size: 1em;
    font-weight: 600;
    margin-left: 0;
    padding: 14px 22px;
    text-align: center;
    text-decoration: none !important;
    transition: box-shadow 0.2s, background 0.1s ease-in-out, border-color 0.1s ease-in-out;
    white-space: nowrap;
    width: auto;

    &:hover {
      background: #444;
      border-color: #444;
      color: #fff !important;
      cursor: pointer;
      text-decoration: none;
    }
  `,
};

const ButtonLink = styled(Link)`
  ${props => styles[props.buttonType ? props.buttonType : 'default']}
`;
const Button = styled('div')`
  ${props => styles[props.buttonType ? props.buttonType : 'default']}
`;

export const buttonStyles = styles;
export const ActionButton = Button;
export default ButtonLink;
